exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (max-width:768px){.restaurants-menucard-component{text-align:center}}.restaurants-menucard-component__title{padding-top:8px}.restaurants-menucard-component__when-where__black-text{color:#555}.restaurants-menucard-component__when-where-title{margin-bottom:0!important}.restaurants-menucard-component__menu-list__black-text{color:#555}.restaurants-menucard-component__menu-list-title{margin-bottom:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/pages/restaurants/menucard.scss
// module id = 1028
// module chunks = 0